/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  FormGroup,
  Spinner,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//Redux
import { useDispatch, useSelector } from "react-redux";

import {
  createAvailability,
  getAvailability,
  editAvailability,
  resetAvailability,
  resetError,
} from "../../store/availability/actions";

import { isArray } from "../../Libs/CustomMethods/customMethods";

const Availability = ({ t }) => {
  let { idAvailability } = useParams();
  let history = useHistory();
  const dispatch = useDispatch();
  const goBack = () => {
    dispatch(resetAvailability());
    history.push("/availabilities");
  };

  const availabilities = useSelector(
    (state) => state.Login.data.availabilities?.[2]
  );

  const {
    loadingAvailabilityEditCreate,
    errorAvailabilityCRUD,
    successAvailability,
    dataAvailabilityEditCreate,
    dataAvailabilityGetSet,
  } = useSelector((state) => state.Availability);
  const [newFields, setNewFields] = useState({ global: true, editable: true });

  const handleCreateEditAvailability = () => {
    const objectFromNewFields = newFields;

    if(objectFromNewFields.type !== "backsoon")
      delete objectFromNewFields.associatedPauseId
    
    if(newFields.name){
      newFields.name = newFields.name.trim();
    }
    idAvailability
      ? dispatch(editAvailability(idAvailability, newFields))
      : dispatch(createAvailability(newFields));
  };

  useEffect(() => {
    idAvailability && dispatch(getAvailability(idAvailability));
  }, [idAvailability]);

  let showToast = function (type, msg) {
    toastr[type](msg);
  };

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successAvailability && goBack(),
  };
  useEffect(() => {
    if (errorAvailabilityCRUD) {
      if (isArray(errorAvailabilityCRUD)) {
        errorAvailabilityCRUD.forEach(
          (error) => error?.value && showToast("error", t(error.value))
        );
      } else {
        showToast("error", t(errorAvailabilityCRUD));
      }
      dispatch(resetError());
    }
  }, [errorAvailabilityCRUD]);

  useEffect(() => {
    if (successAvailability) {
      showToast("success", t(dataAvailabilityEditCreate?.message));
    }
  }, [successAvailability]);

  useEffect(() => {
    if (dataAvailabilityGetSet) {
      setNewFields((prev) => ({ ...prev, type: dataAvailabilityGetSet.data?.type }));
    }
  }, [dataAvailabilityGetSet]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/availability"
            onclick={goBack}
            title={t("Back to the previous page")}
            breadcrumbItem={t("Availability")}
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleCreateEditAvailability}>
                    <Row className="mb-3">
                      <Col sm="12" md="6">
                        <FormGroup>
                          <AvField
                            value={
                              dataAvailabilityGetSet
                                ? dataAvailabilityGetSet?.data.name
                                : ""
                            }
                            onChange={(e) => {
                                setNewFields((prev) => ({
                                    ...prev,
                                    name: e.target.value,
                                  }))
                            }}
                            label={t("Name") + " *"}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter name")}
                            validate={{
                              required: {
                                value: idAvailability ? true : false,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 255,
                                errorMessage: t("Invalid field"),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t(
                                  "Name must be at least 3 characters long"
                                ),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="12" md="6">
                        <FormGroup>
                          <AvField
                            value={
                              dataAvailabilityGetSet
                                ? dataAvailabilityGetSet?.data.description
                                : ""
                            }
                            onChange={(e) => {
                              setNewFields((prev) => ({
                                    ...prev,
                                    description: e.target.value,
                                  }))
                            }}
                            label={t("Description") + " *"}
                            id="description"
                            name="description"
                            type="text"
                            className="form-control"
                            placeholder={t("Description")}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 255,
                                errorMessage: t("Invalid field"),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t(
                                  "Description must be at least 3 characters long"
                                ),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12" md="6" lg="2">
                        <FormGroup>
                          <AvField
                            value={
                              dataAvailabilityGetSet
                                ? dataAvailabilityGetSet?.data.type
                                : ""
                            }
                            name="type"
                            className="form-control"
                            type="select"
                            label={t("Type")}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                            onChange={(e) => {
                              setNewFields((prev) => ({
                                    ...prev,
                                    type: e.target.value,
                                  }))
                            }}
                          >
                            <option value="">{t("Select")}</option>
                            <option value="backsoon">
                              {t("backsoon").toUpperCase()}
                            </option>
                            <option value="away">
                              {t("away").toUpperCase()}{" "}
                            </option>
                          </AvField>
                        </FormGroup>
                      </Col>
                      {newFields.type === "backsoon" && (
                        <Col sm="12" md="6" lg="2">
                          <FormGroup>
                            <AvField
                              value={
                                dataAvailabilityGetSet
                                  ? dataAvailabilityGetSet?.data
                                      .associatedPauseId
                                  : ""
                              }
                              name="associatedPauseId"
                              className="form-control scroll variable"
                              type="select"
                              label={t("Associate Pause")}
                              onChange={(e) => {
                                setNewFields((prev) => ({
                                      ...prev,
                                      associatedPauseId: e.target.value,
                                    }))
                              }}
                            >
                              <option value="">{t("None")}</option>
                              {availabilities?.children?.map((avail) => (
                                <option
                                  className="capitalize"
                                  key={avail.id}
                                  value={avail.id}
                                >
                                  {avail.name}
                                </option>
                              ))}
                            </AvField>
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                    {loadingAvailabilityEditCreate ? (
                      <Button
                        disabled={true}
                        style={{
                          width: "100px",
                          cursor: "no-drop",
                        }}
                        color="primary"
                        className="mr-1 waves-effect waves-light"
                      >
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      </Button>
                    ) : (
                      <Button
                        color="primary"
                        className="mr-1 waves-effect waves-light"
                        type="submit"
                      >
                        {t("Confirm")}
                      </Button>
                    )}
                    <Button
                      onClick={goBack}
                      type="button"
                      color="secondary"
                      className="waves-effect btn-dark"
                    >
                      {t("Cancel")}
                    </Button>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Availability);
